import {useEffect, useState, useMemo, useRef} from "react";

export const usePagination = (data) => {
  const {
    firstRequest = true,
    key = null,
    customParams = {},
    initialPerPage = 20,
    withMeta = false,
    latestRequestOnly = false
  } = data;
  const [state, setState] = useState([]);

  const [result, setResult] = useState({});
  const [meta, setMeta] = useState({});

  // пагинация
  const [params, setParams] = useState({
    totalCount: 0, //есть всего элементов
    currentPage: 1, //текущая страница
    perPage: initialPerPage, // количество элементов на странице
  });

  const totalPages = useMemo(() => {
          if (params.perPage == 0 || params.totalCount == 0) return 1;
          return Math.ceil(params.totalCount / params.perPage);
      }, [params.totalCount, params.perPage]);

  const setPerPage = (value) => {
    setParams((prev) => ({
        ...prev,
        perPage: value
    }))
  } 
  
  const setCurrentPage = (value) => {
    setParams((prev) => ({
        ...prev,
        currentPage: value
    }))
  }

  const nextPage = () => {
      setParams((prev) => ({
        ...prev,
        currentPage: Math.min(prev.currentPage + 1, totalPages)
      }))
  }
  const prevPage = () => {
      setParams((prev) => ({
        ...prev,
        currentPage: Math.max(prev.currentPage - 1, 1)
      }))
  }

  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  // метод загрузки
  const getState = (options = {}) => {
    const { customParams = {}, page = params.currentPage } = options;
    const currentRequestId = ++requestId.current;
    setFirstRenred(false);
    setState([]);
    setLoading(true);
    const dataParams = {
        ...data.params,
        ...customParams,
        paramsPagination: {
            perPage: params.perPage,
            page
        }
    }
    return data.api(dataParams).then((res) => {
      if (latestRequestOnly && currentRequestId !== requestId.current) return;
      setLoading(false);
      let listData;
      if (res?.data?.payments) {
        listData = res?.data.payments;
      } else {
        listData = key ? res?.data[key] : res?.data;
      }

      if (key) setResult(res?.data);

      if (listData?.data !== undefined) {
        const listMeta = listData?._meta ?? listData?.meta ?? {};
        const totalCount = listMeta?.totalCount ?? listMeta?.total;

        if(withMeta){
          setMeta(listMeta);
        }
        setState(listData.data);
        if(totalCount !== undefined && totalCount !== params.totalCount){
            setParams((prev) => (
                {   
                    ...prev,
                    totalCount: totalCount,
                }
            ));
        }
      }
    });
  };

  const [firstRenred, setFirstRenred] = useState(!firstRequest);
  useEffect(()=>{
    if(firstRenred){
      setFirstRenred(false);
      return;
    }
    if(data.api){
      getState(customParams);
    }
  }, [params.currentPage, params.perPage]);

  return {
    state,
    getState,
    setState,
    loading,
    result,
    meta: withMeta ? meta : undefined,

    totalCount: params.totalCount,
    perPage: params.perPage,
    currentPage: params.currentPage,
    setPerPage,
    setCurrentPage,
    prevPage,
    nextPage,
    totalPages
  };
};

export default usePagination;
